import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { RenewalPlanPeriodResponse, getRenewalPlanPeriod } from 'core'
import { BenefitDesignStatus } from 'core/domain/benefit/benefitDesignStatus'

import Alert from 'common/components/feedback/Alert'
import Button from 'common/components/general/Button'

import { Col, Row } from 'common/components'
import { useCommandRequest, useQueryRequest } from 'common/hooks'

import { ROUTE_PATHS } from '../../../../../common/routePaths'

type RenewalDesignInfoBoxProps = {
  renewalPlanPeriod: RenewalPlanPeriodResponse
  renewalDecisionHandler: (useSame: boolean) => Promise<any>
}

const RenewalDesignInfoBox: React.FC<RenewalDesignInfoBoxProps> = ({ renewalPlanPeriod, renewalDecisionHandler }) => {
  const history = useHistory()
  const { t: translate } = useTranslation()

  const [sendCommand, isCommandLoading] = useCommandRequest()

  const onSubmit = async (useSame: boolean) => {
    const result = await sendCommand(() => renewalDecisionHandler(useSame))
    if (result.completed) {
      if (useSame) {
        history.push(`${ROUTE_PATHS.RENEWAL_TASKS}`)
      } else {
        history.push(`${ROUTE_PATHS.DESIGN_BENEFIT_PATH}/${renewalPlanPeriod.id}`)
      }
    }
  }

  const onViewBenefit = async () => {
    history.push(`${ROUTE_PATHS.DESIGN_BENEFIT_PATH}/${renewalPlanPeriod.id}`)
  }

  return (
    <>
      {renewalPlanPeriod.status !== BenefitDesignStatus.Signed && (
        <Alert
          className={'mb-16'}
          type="warning"
          message={
            <Row gutter={16} align={'middle'} justify={'space-between'}>
              <Col>
                <h4 className={'mb-0'}>
                  {translate('admin-dashboard.benefit-details.benefit-redesign.benefit-redesign-active')}
                </h4>
              </Col>

              <Col>
                <Button
                  type="primary"
                  className={'mr-16'}
                  disabled={isCommandLoading}
                  loading={isCommandLoading}
                  onClick={() =>
                    renewalPlanPeriod.status == BenefitDesignStatus.NotStarted ? onSubmit(false) : onViewBenefit()
                  }
                >
                  {translate('admin-dashboard.benefit-details.benefit-redesign.make-changes')}
                </Button>

                {renewalPlanPeriod.status === BenefitDesignStatus.NotStarted && (
                  <Button
                    type="default"
                    disabled={isCommandLoading}
                    loading={isCommandLoading}
                    onClick={() => onSubmit(true)}
                  >
                    {translate('admin-dashboard.benefit-details.benefit-redesign.use-same')}
                  </Button>
                )}
              </Col>
            </Row>
          }
          showIcon
        />
      )}
    </>
  )
}

export default RenewalDesignInfoBox
